import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=8384bee2&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
import style0 from "./Order.vue?vue&type=style&index=0&id=8384bee2&prod&lang=scss"
import style1 from "./Order.vue?vue&type=style&index=1&id=8384bee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384bee2",
  null
  
)

export default component.exports